import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { GET_LOGIN_LOGS, GetLoginLogsResponse } from "../graphql/queries/getLoginLogs";

export interface LoginLogFilters {
  phone?: string;
  operationType?: string;
  loginResult?: string;
  clientType?: string;
  startTime?: number;
  endTime?: number;
}

export const useLoginLogQuery = (filters: LoginLogFilters, page: number, pageSize: number) => {
  const variables = useMemo(() => ({
    filters: {
      phone: filters.phone || undefined,
      operationType: filters.operationType || undefined,
      loginResult: filters.loginResult || undefined,
      clientType: filters.clientType || undefined,
      startTime: filters.startTime || undefined,
      endTime: filters.endTime || undefined,
    },
    pageRequest: {
      page,
      size: pageSize,
      sortBy: "createdAt",
      sortDirection: "DESC",
    },
  }), [filters, page, pageSize]);

  const { data, loading, refetch } = useQuery<GetLoginLogsResponse>(
    GET_LOGIN_LOGS,
    { variables, fetchPolicy: "network-only" }
  );

  return {
    data: data?.getLoginLogs?.content || [],
    total: data?.getLoginLogs?.totalElements || 0,
    loading,
    refetch,
  };
};
